var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('billsearchinput',{ref:"billsearchinput",attrs:{"url":_vm.url,"initForm":_vm.initForm,"initTable":_vm.initTable,"inputProperty":_vm.inputProperty,"propertyObject":_vm.propertyObject,"label":""}})}
var staticRenderFns = []

export { render, staticRenderFns }